import { FC, useCallback, useEffect } from "react";
import CategorySectionCreator from "components/CategorySectionCreator";
import VideoLabelIcon from "@mui/icons-material/VideoLabel";
import modules from "modules";
import { useAppDispatch } from "hooks/use-app-dispatch";
import { useAppSelector } from "hooks/use-app-selector";
import NewProductCard from "components/product-cards/NewProductCard";
import SwiperCarousel from "components/swiper/SwiperCarousel";

const { actions: productsActions, selectors: productsSelectors } =
  modules.products;

const breakpoints = {
  0: { slidesPerView: 1.25 },
  600: { slidesPerView: 1.25 },
  900: { slidesPerView: 3.25 },
  1200: { slidesPerView: 5.25 },
  1536: { slidesPerView: 5.25 },
};

// =============================================================
type Props = {
  productName?: string;
  productCategory?: string;
  current_product_id?: string;
};
// =============================================================

const AlternativeProductCarousel: FC<Props> = ({
  productCategory,
  current_product_id,
}) => {
  const dispatch = useAppDispatch();

  const alternativeProducts = useAppSelector(
    productsSelectors?.selectAlternativeProducts
  );

  const isAlternativeLoading = useAppSelector(
    productsSelectors?.selectAlternativeProductsLoading
  );

  const getAlternativeProduct = useCallback(async () => {
    try {
      await dispatch(
        productsActions?.getAlternativeProductsThunk({ current_product_id })
      );
    } catch (error) {
      console.error(error);
    }
  }, [current_product_id, dispatch]);

  useEffect(() => {
    getAlternativeProduct();
  }, [getAlternativeProduct]);

  return alternativeProducts?.[0] ? (
    <CategorySectionCreator
      icon={<VideoLabelIcon color="secondary" fontSize="small" />}
      title={alternativeProducts?.length > 0 && `Alternative Products`}
      titleFontSize="large"
    >
      <SwiperCarousel
        id="products"
        data={alternativeProducts}
        renderItem={(item) => <NewProductCard hoverEffect productData={item} />}
        isLoading={isAlternativeLoading}
        breakpoints={breakpoints}
      />
    </CategorySectionCreator>
  ) : null;
};

export default AlternativeProductCarousel;
